module.exports = __webpack_public_path__ + "components/MapControl/svg/Salon piękności_fryzjer_kosmetyczka.svg?ed3d3160";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Salon piękności_fryzjer_kosmetyczka.svg
// module id = 2095
// module chunks = 0